// extracted by mini-css-extract-plugin
export var image = "dT_H";